// extracted by mini-css-extract-plugin
module.exports = {"lightColour":"#FAFCFC","container":"Profile_container__6rKsc"};